import {
    Box,
    Typography,
    Card,
    Divider,
    Grid,
    Button,
    useTheme,
    IconButton,
    Menu,
    MenuItem,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    TextField,
} from "@mui/material";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { useEffect, useState } from "react";
import QuoteDetailsEditModal from "./QuoteDetailsEditModal";
import axiosInstance from "../../axiosInstance";
import Swal from "sweetalert2";
import { useSelector } from "react-redux";
import BreadCrumbs from "../../components/Breadcrumbs";
import { useTranslation } from "react-i18next";

const paraFormat = (value) =>
    new Intl.NumberFormat("en-GB", {
        style: "currency",
        currency: "GBP",
    }).format(value || 0);

const QuoteDetailsEdit = () => {
    const { t } = useTranslation();

    const { optionId } = useParams();
    const location = useLocation();
    const navigate = useNavigate();
    const theme = useTheme();
    const lightMode = useSelector((state) => state.mode.lightMode);

    const option = location.state?.option;

    const [selectedOption, setSelectedOption] = useState(option || null);
    const [menuAnchor, setMenuAnchor] = useState(null);
    const [selectedCourse, setSelectedCourse] = useState(null);
    const [editOpen, setEditOpen] = useState(false);

    const [modalType, setModalType] = useState("edit");

    const handleGetOptionDetails = async () => {

        try {
            // setLoader(true);
            const url = `${process.env.REACT_APP_BASE_URL}quote_option/${selectedOption.option_id}`;
            const accessToken = localStorage.getItem("accessToken");
            const token = localStorage.getItem("loginUser");

            const response = await axiosInstance.get(url, {
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                    XRefreshToken: `${token}`,
                    "Content-Type": "application/json",
                },
            });

            const optionData = response.data;

            setSelectedOption(optionData)
        } catch (error) {
            console.error("Option edit fetch error:", error);
        } finally {
            // setLoader(false);
        }
    };

    const handleMenuOpen = (e, course) => {
        setMenuAnchor(e.currentTarget);
        setSelectedCourse(course);
    };

    const handleMenuClose = () => {
        setMenuAnchor(null);
    };

    const handleEdit = (modalType) => {
        handleMenuClose();
        setEditOpen(true);
        setModalType(modalType)
    };

    const handleDelete = async () => {
        handleMenuClose();

        if (!selectedCourse?.option_course_id) {
            console.error("No course selected or missing ID.");
            return;
        }

        try {
            const accessToken = localStorage.getItem("accessToken");
            const token = localStorage.getItem("loginUser");

            const url = `${process.env.REACT_APP_BASE_URL}quote_option_course/${selectedCourse.option_course_id}`;

            const response = await axiosInstance.delete(url, {
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                    XRefreshToken: `${token}`,
                    "Content-Type": "application/json",
                },
            });

            console.log("Deleted course:", response.data);
            Swal.fire({
                icon: 'success',
                title: `${t("accommodationDeleted")}!`,
                text: `${t("accommodationDeletedText")}`,
                confirmButtonText: 'Close',
                showCloseButton: true
            });
            await handleGetOptionDetails();
        } catch (error) {
            console.error("Error deleting course:", error.message);
        }
    };


    const handleEditClose = () => {
        setEditOpen(false);
    };

    async function addCourseToOption(data) {
        const accessToken = localStorage.getItem("accessToken");
        const token = localStorage.getItem("loginUser");
        try {
            const params = {
                option_id: data?.option_id,
                courses: [
                    {
                        course_id: data?.course_id,
                        campus_id: data?.campus_id,
                        option_course_name: data?.option_course_name,
                        option_course_partner: data?.option_course_partner,
                        option_course_campus: data?.option_course_campus,
                        option_course_start_date: data?.option_course_start_date,
                        option_course_end_date: data?.option_course_end_date,
                    }
                ]
            }
            const url = `${process.env.REACT_APP_BASE_URL}quote_option_course`;
            const response = await axiosInstance.post(url, params, {
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                    XRefreshToken: `${token}`,
                    "Content-Type": "application/json",
                },
            });
            console.log(response.data, 'added course to option');

            Swal.fire({
                icon: 'success',
                title: `${t("accommodationAdded")}!`,
                text: `${t("accommodationAddedText")}`,
                confirmButtonText: 'Close',
                showCloseButton: true
            });
            await handleGetOptionDetails()
        } catch (error) {
            console.error("Error during the request:", error.message);
        }
    }

    useEffect(() => {
        console.log(selectedOption, 'selected option here');
    }, [selectedOption])

    useEffect(() => {
        handleGetOptionDetails()
    }, [])

    async function updateOptionCourse(data) {
        const accessToken = localStorage.getItem("accessToken");
        const token = localStorage.getItem("loginUser");

        console.log(data, 'DAT HERE');

        try {
            const params = {
                option_course_id: data?.option_course_id,
                course_id: data?.course_id,
                option_course_start_date: data?.option_course_start_date,
                option_course_end_date: data?.option_course_end_date,
            }
            const url = `${process.env.REACT_APP_BASE_URL}quote_option_course`;
            const response = await axiosInstance.put(url, params, {
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                    XRefreshToken: `${token}`,
                    "Content-Type": "application/x-www-form-urlencoded",
                },
            });

            Swal.fire({
                icon: 'success',
                title: 'Accommodation Updated',
                text: 'The selected accommodation has been successfully updated!',
                confirmButtonText: 'Close',
                showCloseButton: true
            });
            await handleGetOptionDetails()

            console.log(response.data, 'added course to option');

        } catch (error) {
            console.error("Error during the request:", error.message);
        }
    }

    const onUpdate = (data) => {
        console.log(data, 'DATA');
        if (modalType === "add") {
            addCourseToOption(data)
        } else {
            updateOptionCourse(data)
        }
        return data
    }

    if (!option || !selectedOption.courses?.length) {
        return <Typography>No Option Data Found</Typography>;
    }

    const firstCourse = selectedOption?.courses?.[0];
    let subTotalAccs = 0;
    let subTotalFees = 0;

    return (
        <Box>
            <BreadCrumbs routs={[t("quotes"), t("editQuote")]} />

            <Box display={"flex"} flexDirection={{ xs: 'column', lg: 'row' }}>
                {/* LEFT CARD (Price Summary) */}
                <Card
                    elevation={0}
                    sx={{
                        display: "flex",
                        flexDirection: "column",
                        maxWidth: { xs: '100%', lg: "400px" },
                        width: "100%",
                        mb: 4,
                        mr: 4,
                        maxHeight: 'fit-content',
                        position: 'sticky',
                        top: 32,
                        left: 0
                    }}
                >
                    <Box sx={{
                        padding: '1rem',
                        height: "300px",
                    }}>
                        <img
                            src={
                                firstCourse?.course?.images?.[0]?.replace("devcrm1", "crm") ||
                                "https://via.placeholder.com/400"
                            }
                            alt="accommodation"
                            style={{
                                width: "100%",
                                height: '100%',
                                objectFit: "cover",
                                borderRadius: '1rem',
                            }}
                        />
                    </Box>
                    <Box sx={{ px: 2, pb: '1rem' }}>
                        <Typography letterSpacing={'2px'} variant="h6" fontWeight={500}>{selectedOption.name}</Typography>
                        <Box mt={2}>
                            <Typography sx={{ color: "red", fontWeight: 600 }}>
                                {t("accommodations")}
                            </Typography>
                            {selectedOption.courses?.map((course, index) => {

                                subTotalAccs += course?.option_course_subtotal_price
                                return (
                                    <>
                                        <Box display="flex" justifyContent="space-between">
                                            <Typography>{course?.option_course_name}</Typography>
                                            <Typography>
                                                {paraFormat(course?.option_course_subtotal_price)}
                                            </Typography>
                                        </Box>
                                        <Typography textTransform={"capitalize"} fontSize="13px" color="gray">
                                            {course?.option_course_duration} {t("day")}
                                        </Typography>
                                    </>
                                )
                            }
                            )}
                        </Box>

                        <Typography textTransform={"capitalize"} fontSize="14px" color="gray">
                            {t("subTotal")}: {paraFormat(subTotalAccs)}
                        </Typography>

                        <Divider sx={{
                            my: 2,
                            borderBottom: `1px dashed ${lightMode ? "#e9ecee" : "#333e47"}`,
                        }} />

                        <Typography textTransform={"capitalize"} sx={{ color: "red", fontWeight: 600 }}>{t("fees")}</Typography>
                        {selectedOption.services?.map((fee) => {
                            subTotalFees += fee?.option_service_gross_price
                            return (
                                <Box
                                    key={fee?.option_service_name}
                                    display="flex"
                                    justifyContent="space-between"
                                    alignItems="center"
                                >
                                    <Typography>
                                        {fee?.option_service_name}{" "}
                                        <Typography component="span" fontSize="12px">
                                            +VAT ({paraFormat(fee?.option_service_vat)})
                                        </Typography>
                                    </Typography>
                                    <Typography>
                                        {paraFormat(fee?.option_service_gross_price)}
                                    </Typography>
                                </Box>
                            )
                        })}

                        <Typography textTransform={"capitalize"} fontSize="14px" color="gray" mt={2}>
                            {t("subTotal")}:{" "}
                            {paraFormat(subTotalFees)}
                        </Typography>

                        <Divider sx={{
                            my: 2,
                            borderBottom: `1px dashed ${lightMode ? "#e9ecee" : "#333e47"}`,
                        }} />

                        <Box display="flex" justifyContent="space-between">
                            <Typography textTransform={"capitalize"} fontWeight={700}>{t("total")}:</Typography>
                            <Typography fontWeight={700}>
                                {paraFormat(subTotalAccs + subTotalFees)}
                            </Typography>
                        </Box>
                    </Box>
                </Card>

                {/* RIGHT SIDE - ACCOMMODATION LIST */}
                <Box sx={{ flex: 1 }}>
                    {selectedOption.courses?.map((course, index) => (
                        <Card
                            key={index}
                            sx={{
                                mb: 3,
                                p: 2,
                                position: "relative",
                            }}
                        >
                            <IconButton
                                sx={{ position: "absolute", top: 10, right: 10 }}
                                onClick={(e) => handleMenuOpen(e, course)}
                            >
                                <MoreVertIcon />
                            </IconButton>

                            <Typography textTransform={"capitalize"} variant="h6" mb={2}>
                                {t("accommodation")} {index + 1}
                            </Typography>

                            <Divider sx={{
                                my: 2,
                                borderBottom: `1px dashed ${lightMode ? "#e9ecee" : "#333e47"}`,
                            }} />

                            <Grid container spacing={2}>
                                <Grid item xs={6}>
                                    <Typography sx={{ textTransform: 'capitalize' }} fontWeight={600}>{t("provider")}</Typography>
                                    <Typography>{course.option_course_partner}</Typography>
                                </Grid>
                                <Grid item xs={6}>
                                    <Typography sx={{ textTransform: 'capitalize' }} fontWeight={600}>{t("residence")}</Typography>
                                    <Typography>{course.option_course_campus}</Typography>
                                </Grid>

                                <Grid item xs={12}>
                                    <Divider sx={{
                                        borderBottom: `1px dashed ${lightMode ? "#e9ecee" : "#333e47"}`,
                                    }} />
                                </Grid>

                                <Grid item xs={6}>
                                    <Typography sx={{ textTransform: 'capitalize' }} fontWeight={600}>{t("type")}</Typography>
                                    <Typography>{course.option_course_name}</Typography>
                                </Grid>
                                <Grid item xs={6}>
                                    <Typography sx={{ textTransform: 'capitalize' }} fontWeight={600}>{t("duration")}</Typography>
                                    <Typography>{course.option_course_duration} {t("day")}</Typography>
                                </Grid>

                                <Grid item xs={12}>
                                    <Divider sx={{
                                        borderBottom: `1px dashed ${lightMode ? "#e9ecee" : "#333e47"}`,
                                    }} />
                                </Grid>

                                <Grid item xs={6}>
                                    <Typography sx={{ textTransform: 'capitalize' }} fontWeight={600}>{t("checkIn")}</Typography>
                                    <Typography>{course.option_course_start_date}</Typography>
                                </Grid>
                                <Grid item xs={6}>
                                    <Typography sx={{ textTransform: 'capitalize' }} fontWeight={600}>{t("checkOut")}</Typography>
                                    <Typography>{course.option_course_end_date}</Typography>
                                </Grid>
                            </Grid>
                        </Card>
                    ))}
                    <Box display={"flex"} flexDirection={{ xs: 'column', sm: 'row' }} gap={2}>
                        <Button sx={{ textTransform: 'capitalize' }} onClick={() => handleEdit("add")} variant="contained" color="primary">{t("addAnotherAccommodation")}</Button>
                        <Button
                            sx={{
                                textTransform: 'capitalize',
                                ml: 'auto',
                                width: { xs: '100%', sm: 'auto' }
                            }}

                            variant="outlined"
                            onClick={() => navigate(-1)}
                        >
                            {t("goBack")}
                        </Button>
                    </Box>
                </Box>
            </Box>

            {/* MENU */}
            <Menu anchorEl={menuAnchor} open={Boolean(menuAnchor)} onClose={handleMenuClose}>
                <MenuItem sx={{ textTransform: 'capitalize' }} onClick={() => handleEdit("edit")}>{t("edit")}</MenuItem>
                <MenuItem sx={{ textTransform: 'capitalize' }} onClick={handleDelete}>{t("delete")}</MenuItem>
            </Menu>

            {/* EDIT MODAL */}
            <QuoteDetailsEditModal selectedOption={selectedOption} setSelectedOption={setSelectedOption} modalType={modalType} setModalType={setModalType} setSelectedCourse={setSelectedCourse} editOpen={editOpen} handleEditClose={handleEditClose} selectedCourse={selectedCourse} onUpdate={onUpdate} />
        </Box>
    );
};

export default QuoteDetailsEdit;
